







import Vue from 'vue';
import Toast from "@/components/util/Toast.vue";
import SkillSearch from "@/components/skill/SkillSearch.vue";

export default Vue.extend({
    components: {
        SkillSearch,
    },
    computed: {
        initialQuery(): string {
            return this.$route.query.q || '';
        }
    },
    methods: {
        onSearchQuery(query: string) {
            const location = {
                ...this.$route,
                query: {
                    ...this.$route.query,
                    q: query,
                },
            };

            //  replace, not push: SkillSearch emits `query` on every search
            //  (live search fires on every keystroke, not just an explicit
            //  submit), so `push` would fill the history stack with one
            //  entry per keystroke.
            this.$router.replace(location);
        }
    }
});
